var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['embed-table-cell', { 'embed-table-cell--header': _vm.header }],style:(_vm.cellStyle),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }